import { render, staticRenderFns } from "./VxTableSimple.vue?vue&type=template&id=1ff106b0&"
import script from "./VxTableSimple.vue?vue&type=script&lang=js&"
export * from "./VxTableSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports